export default "__VITE_ASSET__M$t3zlRB__"